export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/shareholder-haneda.f19e07c1-b08948.png";